import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { withRouter } from "react-router-dom";
import Media from "react-media";
// components
import Activate from "./Activate";
import WarningPopup from "../WarningPopup";
// js
import OpenClose from "../../assets/images/open_close.js";
// images
import see_more from "../../assets/images/see_more.png";
// styles
import styles from "./Header.module.css";

class Header extends Activate {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      subMenu: false,
      modalOpen: false,
    };
  }

  setActive() {
    super.setActive();
    let scrollTop =
      document.querySelector("body").scrollTop ||
      document.querySelector("html").scrollTop;

    document.body.style.top = -1 * scrollTop + "px";
    document.body.classList.add("menuOpen");
  }

  setInactive() {
    super.setInactive();
    let top = parseInt(document.body.style.top) * -1;
    document.body.style.top = 0;
    document.body.classList.remove("menuOpen");

    //make sure we only scroll when css is applied
    let style;
    if (window.getComputedStyle) {
      style = window.getComputedStyle(document.body);
    } else {
      style = document.body.currentStyle;
    }
    if (style && style.order === "1") {
      window.scrollTo(0, top);
    }
  }

  openSubMenu = () => {
    //make sure only current menu is opened
    this.setState({ subMenu: true });
  };

  toggleSubMenu = () => {
    this.setState({ subMenu: !this.state.subMenu });
  };

  close = () => {
    this.setInactive();
    this.setState({ subMenu: false });
  };

  toggle = () => {
    if (this.state.active) this.setInactive();
    else this.setActive();
  };

  render() {
    const isDosing = window.location.hostname.indexOf("dosing") !== -1;
    const onDosingPage =
      (isDosing && this.props.location.pathname === "/") ||
      this.props.location.pathname === "/dosing";
    return (
      <div>
        <div className={styles.header}>
          <div className={styles.topLinks}>
            <div className={styles.disclaimer}>
              This site is intended for healthcare professionals in the United
              States
            </div>
            <a
              className={styles.anchorText}
              href="https://firebasestorage.googleapis.com/v0/b/giapreza-db.appspot.com/o/prescribing%2FGIAPREZA.pdf?alt=media"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prescribing information
            </a>
            <span
              className={`${styles.anchorText} ${styles.safetyLink}`}
              onClick={() => this.setState({ modalOpen: true })}
            >
              IMPORTANT SAFETY INFORMATION
            </span>
          </div>
          <a href="https://giapreza.com/" className={styles.logoContainer}></a>
          <div
            onClick={() => this.toggle()}
            className={styles.openClose}
            id={this.state.active ? "menuOpened" : "menuClosed"}
          >
            <OpenClose />
          </div>
          <div
            className={`${styles.navBar} ${
              this.state.active ? styles.openMenu : null
            }`}
          >
            <ul className={styles.navList}>
              <Media query="(max-width: 415px)">
                {(matches) =>
                  matches ? (
                    <>
                      <li className={styles.navItem}>
                        <a href="https://giapreza.com" onClick={this.close}>
                          Home
                        </a>
                      </li>
                      <li className={styles.navItem}>
                        <a
                          href="https://firebasestorage.googleapis.com/v0/b/giapreza-db.appspot.com/o/prescribing%2FGIAPREZA.pdf?alt=media"
                          onClick={this.close}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Prescribing information
                        </a>
                      </li>
                      <li
                        className={`${styles.navItem} ${styles.multiLineNav}`}
                      >
                        <div
                          onClick={() => this.setState({ modalOpen: true })}
                          className={styles.modalNav}
                        >
                          IMPORTANT SAFETY INFORMATION
                        </div>
                      </li>
                    </>
                  ) : null
                }
              </Media>
              <li className={styles.navItem} style={{ width: "207px" }}>
                <a href="https://giapreza.com/about" onClick={this.close}>
                  About Giapreza
                </a>
              </li>
              <li className={styles.navItem} style={{ width: "236px" }}>
                <a href="https://giapreza.com/ordering" onClick={this.close}>
                  Ordering Giapreza
                </a>
              </li>
              <Media query="(min-width: 416px)">
                {(matches) => {
                  return (
                    <li
                      className={`${styles.navItem} ${
                        this.state.subMenu && styles.navItemOpen
                      } ${onDosingPage && styles.activeNav}`}
                      style={{ width: "201px" }}
                      onMouseLeave={() => matches && this.close()}
                      onMouseEnter={() => matches && this.openSubMenu()}
                    >
                      <div
                        className={`${styles.subMenuIcon} ${
                          this.state.subMenu ? styles.subMenuIconActive : null
                        }`}
                        onClick={() => this.toggleSubMenu()}
                      ></div>
                      {isDosing ? (
                        <Link to="/" className={styles.mobileLineItem}>
                          Using GIAPREZA
                        </Link>
                      ) : (
                        <a
                          href="https://dosing.giapreza.com"
                          className={styles.mobileLineItem}
                        >
                          Using GIAPREZA
                        </a>
                      )}
                      <SubMenu close={() => this.close()} />
                    </li>
                  );
                }}
              </Media>
              <li className={styles.navItem} style={{ width: "166px" }}>
                <a href="https://giapreza.com/contact-us" onClick={this.close}>
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
        <WarningPopup
          isOpen={this.state.modalOpen}
          setIsOpen={(val) => this.setState({ modalOpen: val })}
        />
        <Media query="(max-width: 415px)">
          {(matches) =>
            matches ? (
              <>
                <div
                  className={styles.mobileSafety}
                  onClick={() => this.setState({ modalOpen: true })}
                >
                  IMPORTANT SAFETY INFORMATION
                  <img
                    src={see_more}
                    alt="open safety information"
                    className={styles.seeMore}
                  />
                </div>
              </>
            ) : null
          }
        </Media>
        <div id="top"></div>
      </div>
    );
  }
}

class SubMenu extends React.Component {
  render() {
    const isDosing = window.location.hostname.indexOf("dosing") !== -1;
    return (
      <div className={`${styles.subMenuWrapper}`}>
        <ul className={styles.subMenu} onClick={this.props.close}>
          <li className={styles.subMenuItem}>
            {isDosing ? (
              <Link to="#administration" className={styles.mobileLineItem}>
                DOSING AND ADMINISTRATION
              </Link>
            ) : (
              <a
                href="https://dosing.giapreza.com/#administration"
                className={styles.mobileLineItem}
              >
                DOSING AND ADMINISTRATION
              </a>
            )}
          </li>
          <li className={styles.subMenuItem}>
            {isDosing ? (
              <Link to="#preparation" className={styles.mobileLineItem}>
                Supply, Storage and Preparation
              </Link>
            ) : (
              <a
                href="https://dosing.giapreza.com/#preparation"
                className={styles.mobileLineItem}
              >
                Supply, Storage and Preparation
              </a>
            )}
          </li>
          <li className={styles.subMenuItem}>
            {isDosing ? (
              <Link to="#patients" className={styles.mobileLineItem}>
                EXAMPLE CANDIDATE PATIENTS
              </Link>
            ) : (
              <a
                href="https://dosing.giapreza.com/#patients"
                className={styles.mobileLineItem}
              >
                EXAMPLE CANDIDATE PATIENTS
              </a>
            )}
          </li>
        </ul>
      </div>
    );
  }
}

export default withRouter(Header);
